import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const customerFSCTypesAdapter = getAdapter({ idFieldName: 'value' });

const customerFSCTypesSlice = createSlice({
  name: 'customerFSCTypes',
  initialState: customerFSCTypesAdapter.getInitialState(),
  reducers: {
    setCustomerFSCTypes: (state, { payload: { customerFSCTypes } }) => {
      customerFSCTypesAdapter.setAll(state, customerFSCTypes);
    },
  },
});

const selectors = customerFSCTypesAdapter.getSelectors(({ customerFSCTypes }) => customerFSCTypes);

export const getCustomerFSCTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getCustomerFSCTypes = (state) => getCustomerFSCTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setCustomerFSCTypes,
} = customerFSCTypesSlice.actions;

export default customerFSCTypesSlice.reducer;
